export default 'white';